import { render, staticRenderFns } from "./WsCard.vue?vue&type=template&id=0be82750&"
import script from "./WsCard.vue?vue&type=script&lang=js&"
export * from "./WsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports